
export const isMaintenance = process.env.REACT_APP_MAINTENANCE === "false";

export const listAnimation = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        stiffness:300,
        damping:10
      }
    }
}
  
export const item_listAnimation = {
    hidden: { opacity: 0, x:25 },
    show: { 
        opacity: 1, 
        x:0, 
    }

}

export const variants = {
  enter: (direction) => {
    return {
      x: direction > 0 ? 200 : -200,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 200 : -200,
      opacity: 0
    };
  }
};
export const buttonAnimated = {
  whileHover:{scale:.945},
  whileTap:{scale:1.045}
}
